import { parse } from 'querystring';
import * as PlanOut from 'planout';
import Immutable, { getIn } from 'seamless-immutable';

/* istanbul ignore next */
class Experiments extends PlanOut.Experiment {
  configureLogger() {
    return;
    // configure logger
  }

  log(event) {
    // log the event
  }

  setup() {
    // set experiment name, etc.
    this.setName(this.inputs.name);
  }

  previouslyLogged() {
    // check if we’ve already logged an event for this user
    // return this._exposureLogged; is a sane default for client-side experiments
  }

  getParamNames() {
    return this.getDefaultParamNames();
  }

  assign(params, args) {
    params.set(
      args.name,
      new PlanOut.Ops.Random.WeightedChoice({ choices: args.choices, weights: args.weights, unit: args.userId })
    );
  }
}

export const experiment = ({ userId = '', name, config, override, location = Immutable(), salt }) => {
  const qs = parse(getIn(location, ['search'], '')?.replace(/\?/g, ''));
  const choices = getIn(config, [name, 'choices']);
  const weights = getIn(config, [name, 'weights']);
  const exp = new Experiments({ userId, name, choices, weights, salt });

  if (override) {
    exp.addOverride(name, override);
  } else if (getIn(qs, [name])) {
    exp.addOverride(name, getIn(qs, [name]));
  }

  if (salt) {
    exp.setSalt(salt);
  }

  return exp.getParams();
};
